import React from 'react';
import SmartDialog from "../SmartDialog";
import TTLProxy from "../../common/TTLAsyncProxy";
import {MiscEndpoints, UsersEndpoints} from "../../common/ProxyEndpoints";
import HTML from '../../common/HtmlHelpers';
import Utils from "../../common/Utils";
import _ from 'lodash';
import {Button, UncontrolledAlert} from "reactstrap";
import {PaginatedView} from "../PaginatedView";
import MDProgress from "react-md-progress-bar";
import {css} from "glamor";
import PropTypes from 'prop-types';

const listItemStyle = css({

    '&:hover':{
        backgroundColor: "#eeeeee"
    }

});

class AlertConfigurationDialog extends  React.Component {

    static propTypes = {
        onNotificationsUpdated: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = AlertConfigurationDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    async loadState(){

        const { user } = this.state;

        try {

            const res = await this.proxy.processRequest(MiscEndpoints.getActiveNotificationList(user.role));
            this.setState({
                notificationList: res.getPayload()
            });

        }
        catch (e) {

            this.setState({
                 error: e
            });

        }
        finally {
            this.setState({ isBusy: false });
        }

    }

    show(user){

        this.setState(AlertConfigurationDialog.getInitialState({ user }), () =>{

            this._dlg.show();

            return this.loadState();
        });

    }

    async onSubmit(notifications){

        const { user } = this.state;
        const proxy = this.proxy;

        this.setState({ isBusy: true , error: null });

        try {

            const res = await proxy.processRequest(UsersEndpoints.overrideUserActiveNotifications(user.id,notifications));
            if(res.ok){

                if(this.props.onNotificationsUpdated)
                    this.props.onNotificationsUpdated(user);

                //
                HTML.toastSuccess('Update successful');

                //
                this._dlg.hide();

            }
        }
        catch (e) {

            HTML.toastError(Utils.getResponseError(e));

            this.setState({
                error: e
            });

        }
        finally {
            this.setState({ isBusy: false });
        }
    }

    static getInitialState(state){

        return {
            user: state ? state.user : null,
            notifications: state ? _.clone(state.user.notifications || []) : [],
            notificationList: [],
            error: null,
            hasChanges: false,
            isBusy: false
        };
    }

    render(){

        const { notifications , isBusy , notificationList , error , hasChanges } = this.state;
        return <SmartDialog title="Alerts & Notification Configuration" ref={r => this._dlg = r}>

            <PaginatedView data={notificationList}
                           rowHeight={100}
                           renderItem={(item,k) =>{

                               return <div className={`${listItemStyle} p-1`}>

                                   <div className="clearfix">

                                       <div className="pull-left">
                                           <h6>{item.name}</h6>
                                       </div>

                                       <div className="pull-right">
                                           <label className="form-check-inline">
                                               <input type="checkbox" checked={notifications.includes(item.id)} onChange={evt => {

                                                   const checked  = evt.target.checked;
                                                   if(checked){
                                                       notifications.push(item.id);
                                                   }
                                                   else{
                                                       notifications.splice(notifications.findIndex(x => item.id === x),1);
                                                   }

                                                   this.setState({
                                                       notifications,
                                                       hasChanges: true
                                                   });

                                               }} />
                                           </label>
                                       </div>

                                   </div>

                                   <p style={{ color: "#4b4b4b" }}>{item.description}</p>

                               </div>
                           }}
                           height={380}
                           noRowsHeight={150}
                           emptyMessage={<p className="p-3 text-center">No notifications available</p>}/>

            {error && <UncontrolledAlert color={"danger"}><i className="fa fa-exclamation-triangle"/> {Utils.getResponseError(error)}</UncontrolledAlert>}

            <hr/>

            {isBusy && <MDProgress show/>}

            <div className="clearfix">
                <div className="pull-right">
                    <span>
                        <Button color="green" className="mr-1" disabled={!hasChanges} onClick={() => this.onSubmit(notifications)}><i className="fa fa-save"/> Save</Button>
                        <Button onClick={() => this._dlg.hide()}><i className="fa fa-close"/> Cancel</Button>
                    </span>
                </div>
            </div>

        </SmartDialog>

    }
}

export default AlertConfigurationDialog;


// WEBPACK FOOTER //
// ./src/components/AlertsConfigurationDialog/AlertConfigurationDialog.js